import React from "react";
import "../css/BottomNav.css";
import HomeIcon from "@material-ui/icons/Home";
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo";
import StorefrontIcon from "@material-ui/icons/Storefront";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import MenuIcon from "@material-ui/icons/Menu";

import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import DrawerNav from "./DrawerNav";

function BottomNav() {
  const useStyles = makeStyles({
    list: {
      width: 250,
    },
    fullList: {
      width: "auto",
    },
  });

  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list)}
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <DrawerNav />
    </div>
  );

  return (
    <div className="bottomNav">
      <ul>
        <li>
          <HomeIcon />
        </li>
        <li>
          <OndemandVideoIcon />
        </li>
        <li>
          <StorefrontIcon />
        </li>
        <li>
          <GroupWorkIcon />
        </li>
        <li>
          <MenuIcon onClick={toggleDrawer("left", true)} />

          <React.Fragment key="left">
            <Drawer
              anchor={"left"}
              open={state["left"]}
              onClose={toggleDrawer("left", false)}
            >
              {list("left")}
            </Drawer>
          </React.Fragment>
        </li>
      </ul>
    </div>
  );
}

export default BottomNav;
